import {useSelector} from 'react-redux'

import {selectPolicies} from 'features/Policies/policiesSelectors'
import {usePoliciesList} from 'features/Policies/usePolicyQuery'
import {Policy} from 'interfaces'

export function useBasePolicyAndBypassConnection() {
  const {selectedPolicyName} = useSelector(selectPolicies)

  // Check if the policies count is equal to 1
  const policies = usePoliciesList()
  const isSinglePolicy: boolean = policies?.length === 1

  // Check if selected policy is the base policy
  const isBasePolicy: boolean = selectedPolicyName?.trim() === Policy.BasePolicy

  // Check if the policy needs to be colored
  const isBasePolicyToBeColored = policies?.length > 1 && isBasePolicy

  return {
    isBasePolicyToBeColored,
    isSinglePolicy,
    isBasePolicy,
    selectedPolicyName,
  }
}
